import * as dispatchOrdersList from './dispatchOrdersList';
import * as dispatchOrdersForm from './dispatchOrderForm';

const Actions = {
  ...dispatchOrdersList,
  ...dispatchOrdersForm,
};

export default Actions;
